export class WebResponse {
  constructor(data, errMsg, errStack, statusCode, headers) {
    this.data = data || null;
    this.errMsg = errMsg || null;
    this.errStack = errStack || null;
    this.statusCode = statusCode || null;
    this.headers = headers || null;
  }

  hasError() {
    if(this.errMsg || this.errStack || this.statusCode >= 400) return true;

    return false;
  }

  getResponse() {
    return {
      data: this.data,
      error: this.hasError() ? ({ message: this.errMsg, stackTrace: this.errStack, statusCode: this.statusCode }) : null,
      responseHeaders: this.headers
    }
  }
}